export default __webpack_public_path__ + "static/media/3C74B228-AE56-4B6B-9B05-0D6C48D20AF0_1_105_c.32874ce3.jpeg";